// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Profil from './pages/Profil/Profil';
import Projekte from './pages/Projekte/Projekte';
import Lebenslauf from './pages/Lebenslauf/Lebenslauf';
import Kontakt from './pages/Kontakt/Kontakt';
import NotFound from './pages/NotFound/NotFound';
import Footer from './components/Footer/Footer';
import styles from './styles/global.css';

function App() {
    return (
        <Router>
            <Navbar />
            <div className={styles.content }>
                <Routes>
                    <Route path="/" element={<Profil />} />
                    <Route path="/projekte" element={<Projekte />} />
                    <Route path="/lebenslauf" element={<Lebenslauf />} />
                    <Route path="/kontakt" element={<Kontakt />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </div>
            <Footer />
        </Router>
    );
}

export default App;
